import { render } from "./PlayerProfile.vue?vue&type=template&id=efed30d8"
import script from "./PlayerProfile.vue?vue&type=script&lang=js"
export * from "./PlayerProfile.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/pages/PlayerProfile.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "efed30d8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('efed30d8', __exports__)) {
    api.reload('efed30d8', __exports__)
  }
  
  module.hot.accept("./PlayerProfile.vue?vue&type=template&id=efed30d8", () => {
    api.rerender('efed30d8', render)
  })

}


export default __exports__